import { Body } from 'atoms/Typography/Typography';
import styles from './styles.module.css';

export const ResultTitle = ({ title }: { title: string }) => {
  return (
    <Body type="sm" className={styles.resultTitle}>
      {title}
    </Body>
  );
};
